/** Per-document access feedback. The mounted navigation effect owns all polling. */
type AccessOwner = { retry(): void; cancel(): void };
let owner: AccessOwner | null = null;
let unavailable = false;
const listeners = new Set<() => void>();
function publish(value: boolean) {
  if (unavailable === value) return;
  unavailable = value; listeners.forEach(listener => listener());
}
export const controllerAccessUnavailable = () => unavailable;
export function subscribeControllerAccess(listener: () => void) {
  listeners.add(listener); return () => { listeners.delete(listener); };
}
export function retryControllerAccess() { if (unavailable) owner?.retry(); }
export function ownControllerAccess(retry: () => void, cancel: () => void) {
  const current = { retry, cancel }, previous = owner;
  owner = current; previous?.cancel();
  return {
    isCurrent: () => owner === current,
    failed() { if (owner === current) publish(true); },
    succeeded() { if (owner === current) publish(false); },
    release() { if (owner === current) { owner = null; publish(false); } },
  };
}
